import { DOMAIN_PREFIX } from '../../../../constants/staticPageConstants';
import { handleTrack } from '../../../../utils/tracker';
import { Accordion } from '../../../Molecules/accordion';
import { LeftSideArticles } from '../../../cms/layout/articles/leftArticleList';
import { TListData } from '../../utils/types';
import { CATEGORY_TREE } from '../../utils/contants';
import { T_ARTICLE_PROPS } from '../../../cms/layout/types';

export const LeftSideContent = ({
  articleData,
}: T_ARTICLE_PROPS): JSX.Element => {
  const handleEvent = (e: React.MouseEvent | React.TouchEvent) => {
    handleTrack({
      label: 'category',
      obj: e.target,
    });
  };

  const getContent = () => {
    switch (articleData.domain) {
      case 1:
        return (
          <>
            {CATEGORY_TREE.result?.map((item, index) => {
              const { parentCategory } = item;
              const { subcategory } = item;

              return (
                <Accordion
                  key={index}
                  header={parentCategory}
                  accordianHeaderEleClasses="text-[#596C85] font-medium text-s-12 gap-2"
                  detailPanelClasses={'block pl-3'}
                  className="border-b border-b-[#D0D3DD] border-opacity-40 mr-2 py-3"
                >
                  {subcategory?.map((subItem: TListData) => {
                    return (
                      <a
                        data-testid="dropdown-arrow"
                        onClick={handleEvent}
                        className="inline-block w-full my-2 text-font-200 text-s-12 hover:font-medium hover:text-blue-600"
                        key={subItem.SEO_term}
                        href={`/glossary/${subItem.SEO_term}`}
                      >
                        {subItem.H1_1}
                      </a>
                    );
                  })}
                </Accordion>
              );
            })}
          </>
        );
      case 2:
        return (
          <>
            {' '}
            <LeftSideArticles
              relatedPost={articleData.related_posts}
              popularPost={[]}
              interestedPost={articleData.interesting_posts}
              language={articleData.language}
              domainName={
                DOMAIN_PREFIX[articleData.domain]?.domain || 'cleartax.in'
              }
            />
          </>
        );
      default:
        return <> </>;
    }
  };
  return <>{getContent()}</>;
};
